class NetworkError extends Error {
  private errCode: string;

  constructor() {
    super("네트워크 에러가 발생했습니다.");
    this.errCode = "0002";
  }
}

export default NetworkError;
